const initiativeData = {};
const initiativeDataSubscribers = {};

const subscribe = (initiativeKey, callback) => {
  initiativeDataSubscribers[initiativeKey] = initiativeDataSubscribers[initiativeKey] || [];
  initiativeDataSubscribers[initiativeKey].push(callback);

  (initiativeData[initiativeKey] || []).map((data) => callback(data));
  delete initiativeData[initiativeKey];
};

const queue = (initiativeKey, data) => {
  const subscribers = (initiativeDataSubscribers[initiativeKey] || []);
  subscribers.forEach(subscriber => subscriber(data));

  if (!subscribers.length) {
    initiativeData[initiativeKey] = initiativeData[initiativeKey] || [];
    initiativeData[initiativeKey].push(data);
  }
};

module.exports = {
  subscribe,
  queue,
};
